import React, { useState, useEffect } from 'react';
import { Grid, Box, Button, Autocomplete, TextField } from '@mui/material';
// import { AutoComplete } from 'antd';
import { DatePicker, Space } from 'antd';
import type { DatePickerProps } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import { fetchHotelCityDispatch } from '../../reducers/HotelReducer';
import { setSelectedDepart } from '../../reducers/UiReducer';
// const Option = AutoComplete.Option;
const { RangePicker } = DatePicker;

const SearchEngineHotel = () => {
	const [departDate, setDepartDate] = useState('');
	const { depart } = useSelector((state) => state.ui);
	const { hotelcity } = useSelector((state) => state.hotel);
	const [departDateReturn, setDepartDateReturn] = useState('');
	const [open, setOpen] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	const onChangeReturn: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDateReturn(dateString);
	};
	useEffect(() => {
		let formData = {};
		dispatch(fetchHotelCityDispatch(formData));
	}, []);
	const showModal = () => {
		setOpen(true);
	};
	const handleCancel = () => {
		setOpen(false);
	};
	const handleOk = () => {
		// setLoading(true);
		setTimeout(() => {
			// setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleChange = (e) => {
		let cityData = {
			keywords: e.target.value.toLowerCase(),
			limits: 10,
		};
		dispatch(fetchHotelCityDispatch(cityData));
		// dispatch(setSelectedDepart(value));
	};
	// const opsList =
	// 	hotelcity?.result?.length > 0 &&
	// 	hotelcity?.result?.map((l) => {
	// 		return (
	// 			<Option
	// 				value={`${l.city_name} - ${l.country_name},${l.country_code}-${l.city_id}`}>{`${l.city_name} - ${l.country_name},${l.country_code} `}</Option>
	// 		);
	// 	});

	const handleChange2 = (value) => {
		let cityData = {
			keywords: value,
			limits: 10,
		};
		dispatch(fetchHotelCityDispatch(cityData));
	};
	// const opsList2 =
	// 	hotelcity?.result?.length > 0 &&
	// 	hotelcity?.result?.map((l) => {
	// 		return (
	// 			<Option
	// 				value={`${l.city_name} - ${l.country_name},${l.country_code}`}>{`${l.city_name} - ${l.country_name},${l.country_code} `}</Option>
	// 		);
	// 	});
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDate(dateString);
	};
	const handleSubmit = () => {
		let formData = {
			checkInDate: departDateReturn[0],
			checkOutDate: departDateReturn[1],
			noOfNights: 1,
			countryName: depart?.country_name,
			countryCode: depart?.country_code,
			cityName: depart?.city_name,
			cityId: depart?.city_id,
			noOfRooms: 1,
			guestNationality: 'IN',
			adultPax: [2, 2, 2, 2],
			childPax: [0, 0, 0, 0],
			childAge: [],
			preferredCurrencyCode: 'INR',
			hotelCodeList: '0',
			starMaxRating: 5,
			startMinRating: 0,
		};
		navigate('/searchresulthotel', { state: formData });
		// navigate('/searchresulthotel');
	};
	// console.log('depart', depart.split('-')[1].split(','));
	return (
		<div>
			<Grid container spacing={1} alignItems={'center'}>
				<Grid item xs={12} sm={12} md={3} lg={3}>
					<Autocomplete
						id='country-select-demo'
						sx={{ width: '100%' }}
						options={
							hotelcity && hotelcity?.result.length > 0 ? hotelcity.result : []
						}
						autoHighlight
						ListboxProps={{
							className: 'myCustomList',
						}}
						// value={depart}
						getOptionLabel={(option) =>
							`${option.city_name}- ${option.country_name} `
						}
						renderOption={(props, option) => (
							<Box
								component='li'
								sx={{ '& > img': { mr: 2, flexShrink: 0, fontSize: 14 } }}
								{...props}>
								<img
									loading='lazy'
									width='20'
									src={`https://flagcdn.com/w20/${option.country_code.toLowerCase()}.png`}
									srcSet={`https://flagcdn.com/w40/${option.country_code.toLowerCase()}.png 2x`}
									alt=''
								/>
								<p style={{ fontSize: 14, marginLeft: 5 }}>
									{option.city_name} - {option.country_name}
								</p>
							</Box>
						)}
						onChange={(event, value) => {
							dispatch(setSelectedDepart(value));
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								id='standard-basic'
								label='Leaving From'
								variant='standard'
								onChange={handleChange}
								style={{ fontSize: 12 }}
								inputProps={{
									...params.inputProps,
									autoComplete: 'new-password', // disable autocomplete and autofill
								}}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={3} lg={3}>
					<RangePicker
						disabledDate={disabledDate}
						style={{
							width: '100%',
							padding: 8,
							border: 'none',
							borderBottom: '1px solid',
							marginTop: 9,
							borderRadius: '1px',
							boxShadow: 'none',
						}}
						onChange={onChangeReturn}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={3} lg={3}>
					<Button
						onClick={showModal}
						style={{
							textTransform: 'capitalize',
							padding: 7,
							borderBottom: '1px solid',
							width: '100%',
							marginTop: 9,
							borderRadius: 1,
						}}>
						Traveller Class
					</Button>{' '}
					<Modal
						open={open}
						title='Travellers'
						onOk={handleOk}
						onCancel={handleCancel}
						footer={[
							<Button key='back' onClick={handleCancel}>
								OK
							</Button>,
						]}></Modal>
				</Grid>
				<Grid item xs={12} sm={12} md={3} lg={2}>
					<Button
						onClick={handleSubmit}
						variant='contained'
						style={{
							width: '100%',
							background: 'orange',
							fontWeight: 'bold',
							padding: '7px',
						}}>
						Search
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

export default SearchEngineHotel;
